import ProductPageSecondaryBenefitsSection from './ProductPageSecondaryBenefitsSection'

export default ProductPageSecondaryBenefitsSection
